import { useState } from "react";

export default function useDragList(items, onReorder) {
    const [dragIndex, setDragIndex] = useState(null);

    const onDragStart = (i) => (e) => {
        setDragIndex(i);
        e.dataTransfer.effectAllowed = "move";
        // для наглядности можно установить dataTransfer, некоторые браузеры этого требуют
        try { e.dataTransfer.setData('text/plain', String(i)); } catch { }
    };

    const onDragOver = (i) => (e) => { e.preventDefault(); };

    const onDrop = (i) => (e) => {
        e.preventDefault();
        if (dragIndex === null || i === dragIndex) return;
        const next = [...items];
        const [row] = next.splice(dragIndex, 1);
        next.splice(i, 0, row);
        setDragIndex(null);
        onReorder(next);
    };

    const onDragEnd = () => setDragIndex(null);

    return { onDragStart, onDragOver, onDrop, onDragEnd, dragIndex };
}
